import { render, staticRenderFns } from "./MyView.vue?vue&type=template&id=667dda1c&scoped=true&"
import script from "./MyView.vue?vue&type=script&lang=js&"
export * from "./MyView.vue?vue&type=script&lang=js&"
import style0 from "./MyView.vue?vue&type=style&index=0&id=667dda1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667dda1c",
  null
  
)

export default component.exports